<ng-container>
    <div mat-dialog-title>
        <h2>{{"restaurant.Kitchen Information" | translate}}</h2>
        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
    <form [formGroup]="formGroup">
        <mat-dialog-content class="pt-0 pb-0">
            <div class="mat-dialog-body">
                <div class="row">
                    <div class="col-sm-12">
                        <mat-form-field class="form-group mb-0" hideRequiredMarker>
                            <mat-label>{{"restaurant.Kitchen Name" | translate}}</mat-label>
                            <input matInput formControlName="title_EN" maxlength="20">
                            <mat-error *ngIf="hasError('title_EN', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                            <!-- <mat-error *ngIf="hasError('title_EN', 'pattern')">
                                {{ 'forms.EntervalidNameinEnglish' | translate }}
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="form-group mb-0" hideRequiredMarker>
                            <mat-label>{{"restaurant.Kitchen Name In Arabic" | translate}}</mat-label>
                            <input matInput formControlName="title_AR" maxlength="20">
                            <mat-error *ngIf="hasError('title_AR', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                            <!-- <mat-error *ngIf="hasError('title_AR', 'pattern')">
                                {{ 'forms.EntervalidNameinArabic' | translate }}
                            </mat-error> -->
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 mb-3">
                        <div class="grey-list-items">
                            <div class="list-item border border-raduis">
                                <div class="d-flex align-items-center">
                                    <p class="info no-icon font-16 font-weight-normal">{{"restaurant.This Kitchen has KDS (Kitchens items need a process to be served to the guest)" | translate}}</p>
                                </div>
                                <div>
                                    <mat-slide-toggle formControlName="hasKDS"></mat-slide-toggle>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-sm-12">
                        <h4 class="group-title mb-3 mt-3">{{ 'profile.Printer configuration' | translate }}
                        </h4>
                        <mat-form-field class="form-group mb-0" hideRequiredMarker>
                            <mat-label>{{ 'content.Type' | translate }}</mat-label>
                            <mat-select formControlName="printDeviceType" (selectionChange)="onChangeprintDeviceType()">
                                <mat-option>{{'forms.None' | translate}}</mat-option>
                                <mat-option *ngFor="let type of printType" [value]="type.id">
                                 {{type.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-8 mb-2" [ngClass]="{'col-sm-12': formGroup.controls['printDeviceType'].value == 'BlueTooth'}" [hidden]="formGroup.controls['printDeviceType'].value != 'Wifi' && formGroup.controls['printDeviceType'].value != 'BlueTooth'">
                        <mat-form-field class="form-group" hideRequiredMarker>
                            <mat-label *ngIf="formGroup.controls['printDeviceType'].value == 'Wifi'">
                                {{ 'profile.IP' | translate }}
                            </mat-label>
                            <mat-label *ngIf="formGroup.controls['printDeviceType'].value == 'BlueTooth'">
                                {{ 'profile.MAC Address' | translate }}
                            </mat-label>
                            <input matInput formControlName="devicePath" [required]="formGroup.controls['printDeviceType'].value">
                            <mat-error *ngIf="hasError('devicePath', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2" [hidden]="formGroup.controls['printDeviceType'].value != 'Wifi'">
                        <mat-form-field class="form-group" hideRequiredMarker>
                            <mat-label>{{ 'profile.Port' | translate }}</mat-label>
                            <input matInput formControlName="devicePort" [required]="formGroup.controls['printDeviceType'].value == 'Wifi'">
                            <mat-error *ngIf="hasError('devicePort', 'required')">{{ 'forms.Required' | translate }}
                            </mat-error>
                            <mat-error *ngIf="hasError('devicePort', 'pattern')">{{ 'forms.Invalid value' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div> -->
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
            <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
                {{"forms.Save" | translate}}
            </button>
        </mat-dialog-actions>
    </form>
</ng-container>
